/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as AuthAccessDeniedRouteImport } from './routes/_auth/access-denied'
import { Route as AuthInvalidLinkRouteImport } from './routes/_auth/invalid-link'
import { Route as AuthInvitationRouteImport } from './routes/_auth/invitation'
import { Route as AuthLinkExpiredRouteImport } from './routes/_auth/link-expired'
import { Route as AuthLoginVerifyRouteImport } from './routes/_auth/login-verify'
import { Route as AuthMagicLinkSentRouteImport } from './routes/_auth/magic-link-sent'
import { Route as AuthSessionExpiredRouteImport } from './routes/_auth/session-expired'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthenticatedSlugRouteImport } from './routes/_authenticated/$slug'
import { Route as AuthTooManyRequestsRouteImport } from './routes/_auth/too-many-requests.'
import { Route as AuthenticatedSlugIndexRouteImport } from './routes/_authenticated/$slug/index'
import { Route as AuthenticatedSlugAdminRouteImport } from './routes/_authenticated/$slug/admin'
import { Route as AuthenticatedSlugBudgetForecastRouteImport } from './routes/_authenticated/$slug/budget-forecast'
import { Route as AuthenticatedSlugFleetRouteImport } from './routes/_authenticated/$slug/fleet'
import { Route as AuthenticatedSlugFlightsRouteImport } from './routes/_authenticated/$slug/flights'
import { Route as AuthenticatedSlugInvoicesRouteImport } from './routes/_authenticated/$slug/invoices'
import { Route as AuthenticatedSlugMonthlyReportsRouteImport } from './routes/_authenticated/$slug/monthly-reports'
import { Route as AuthenticatedSlugOwnerPortalRouteImport } from './routes/_authenticated/$slug/owner-portal'
import { Route as AuthenticatedSlugPriceLibraryRouteImport } from './routes/_authenticated/$slug/price-library'
import { Route as AuthenticatedSlugSettingsRouteImport } from './routes/_authenticated/$slug/settings'
import { Route as AuthenticatedSlugSupportRouteImport } from './routes/_authenticated/$slug/support'
import { Route as AuthenticatedSlugAdminIndexRouteImport } from './routes/_authenticated/$slug/admin/index'
import { Route as AuthenticatedSlugAdminAiModelsRouteImport } from './routes/_authenticated/$slug/admin/ai-models'
import { Route as AuthenticatedSlugAdminAircraftRouteImport } from './routes/_authenticated/$slug/admin/aircraft'
import { Route as AuthenticatedSlugAdminCrewRouteImport } from './routes/_authenticated/$slug/admin/crew'
import { Route as AuthenticatedSlugAdminOperatorsRouteImport } from './routes/_authenticated/$slug/admin/operators'
import { Route as AuthenticatedSlugAdminOwnersRouteImport } from './routes/_authenticated/$slug/admin/owners'
import { Route as AuthenticatedSlugAdminUsersRouteImport } from './routes/_authenticated/$slug/admin/users'
import { Route as AuthenticatedSlugFleetIndexRouteImport } from './routes/_authenticated/$slug/fleet/index'
import { Route as AuthenticatedSlugFleetAircraftIdRouteImport } from './routes/_authenticated/$slug/fleet/$aircraftId'
import { Route as AuthenticatedSlugInvoicesIndexRouteImport } from './routes/_authenticated/$slug/invoices/index'
import { Route as AuthenticatedSlugInvoicesPeriodRouteImport } from './routes/_authenticated/$slug/invoices/$period'
import { Route as AuthenticatedSlugSettingsIndexRouteImport } from './routes/_authenticated/$slug/settings/index'
import { Route as AuthenticatedSlugSettingsAccountRouteImport } from './routes/_authenticated/$slug/settings/account'
import { Route as AuthenticatedSlugSettingsAppearanceRouteImport } from './routes/_authenticated/$slug/settings/appearance'
import { Route as AuthenticatedSlugSettingsIntegrationsRouteImport } from './routes/_authenticated/$slug/settings/integrations'
import { Route as AuthenticatedSlugSettingsUnitsRouteImport } from './routes/_authenticated/$slug/settings/units'
import { Route as AuthenticatedSlugSettingsWorkspaceRouteImport } from './routes/_authenticated/$slug/settings/workspace'
import { Route as AuthenticatedSlugFleetAircraftIdAircraftRouteImport } from './routes/_authenticated/$slug/fleet/$aircraftId/_aircraft'
import { Route as AuthenticatedSlugFleetAircraftIdAircraftIndexRouteImport } from './routes/_authenticated/$slug/fleet/$aircraftId/_aircraft/index'
import { Route as AuthenticatedSlugFleetAircraftIdAircraftDocumentsRouteImport } from './routes/_authenticated/$slug/fleet/$aircraftId/_aircraft/documents'
import { Route as AuthenticatedSlugFleetAircraftIdAircraftExpensesRouteImport } from './routes/_authenticated/$slug/fleet/$aircraftId/_aircraft/expenses'
import { Route as AuthenticatedSlugFleetAircraftIdAircraftFlightsRouteImport } from './routes/_authenticated/$slug/fleet/$aircraftId/_aircraft/flights'
import { Route as AuthenticatedSlugFleetAircraftIdAircraftInfoRouteImport } from './routes/_authenticated/$slug/fleet/$aircraftId/_aircraft/info'
import { Route as AuthenticatedSlugFleetAircraftIdAircraftOverviewRouteImport } from './routes/_authenticated/$slug/fleet/$aircraftId/_aircraft/overview'
import { Route as AuthenticatedSlugFleetAircraftIdAircraftProgramsRouteImport } from './routes/_authenticated/$slug/fleet/$aircraftId/_aircraft/programs'
import { Route as AuthenticatedSlugFleetAircraftIdOverviewRecentActivityRouteImport } from './routes/_authenticated/$slug/fleet/$aircraftId/overview.recent-activity'
import { Route as AuthenticatedSlugFleetAircraftIdOverviewVendorsRouteImport } from './routes/_authenticated/$slug/fleet/$aircraftId/overview.vendors'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
  id: '/terms-and-conditions',
  path: '/terms-and-conditions',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAccessDeniedRoute = AuthAccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvalidLinkRoute = AuthInvalidLinkRouteImport.update({
  id: '/invalid-link',
  path: '/invalid-link',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvitationRoute = AuthInvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLinkExpiredRoute = AuthLinkExpiredRouteImport.update({
  id: '/link-expired',
  path: '/link-expired',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginVerifyRoute = AuthLoginVerifyRouteImport.update({
  id: '/login-verify',
  path: '/login-verify',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMagicLinkSentRoute = AuthMagicLinkSentRouteImport.update({
  id: '/magic-link-sent',
  path: '/magic-link-sent',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSessionExpiredRoute = AuthSessionExpiredRouteImport.update({
  id: '/session-expired',
  path: '/session-expired',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedSlugRoute = AuthenticatedSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthTooManyRequestsRoute = AuthTooManyRequestsRouteImport.update({
  id: '/too-many-requests/',
  path: '/too-many-requests/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedSlugIndexRoute = AuthenticatedSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedSlugRoute,
} as any)
const AuthenticatedSlugAdminRoute = AuthenticatedSlugAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedSlugRoute,
} as any)
const AuthenticatedSlugBudgetForecastRoute =
  AuthenticatedSlugBudgetForecastRouteImport.update({
    id: '/budget-forecast',
    path: '/budget-forecast',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugFleetRoute = AuthenticatedSlugFleetRouteImport.update({
  id: '/fleet',
  path: '/fleet',
  getParentRoute: () => AuthenticatedSlugRoute,
} as any)
const AuthenticatedSlugFlightsRoute =
  AuthenticatedSlugFlightsRouteImport.update({
    id: '/flights',
    path: '/flights',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugInvoicesRoute =
  AuthenticatedSlugInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugMonthlyReportsRoute =
  AuthenticatedSlugMonthlyReportsRouteImport.update({
    id: '/monthly-reports',
    path: '/monthly-reports',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugOwnerPortalRoute =
  AuthenticatedSlugOwnerPortalRouteImport.update({
    id: '/owner-portal',
    path: '/owner-portal',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugPriceLibraryRoute =
  AuthenticatedSlugPriceLibraryRouteImport.update({
    id: '/price-library',
    path: '/price-library',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugSettingsRoute =
  AuthenticatedSlugSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugSupportRoute =
  AuthenticatedSlugSupportRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugAdminIndexRoute =
  AuthenticatedSlugAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSlugAdminRoute,
  } as any)
const AuthenticatedSlugAdminAiModelsRoute =
  AuthenticatedSlugAdminAiModelsRouteImport.update({
    id: '/ai-models',
    path: '/ai-models',
    getParentRoute: () => AuthenticatedSlugAdminRoute,
  } as any)
const AuthenticatedSlugAdminAircraftRoute =
  AuthenticatedSlugAdminAircraftRouteImport.update({
    id: '/aircraft',
    path: '/aircraft',
    getParentRoute: () => AuthenticatedSlugAdminRoute,
  } as any)
const AuthenticatedSlugAdminCrewRoute =
  AuthenticatedSlugAdminCrewRouteImport.update({
    id: '/crew',
    path: '/crew',
    getParentRoute: () => AuthenticatedSlugAdminRoute,
  } as any)
const AuthenticatedSlugAdminOperatorsRoute =
  AuthenticatedSlugAdminOperatorsRouteImport.update({
    id: '/operators',
    path: '/operators',
    getParentRoute: () => AuthenticatedSlugAdminRoute,
  } as any)
const AuthenticatedSlugAdminOwnersRoute =
  AuthenticatedSlugAdminOwnersRouteImport.update({
    id: '/owners',
    path: '/owners',
    getParentRoute: () => AuthenticatedSlugAdminRoute,
  } as any)
const AuthenticatedSlugAdminUsersRoute =
  AuthenticatedSlugAdminUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSlugAdminRoute,
  } as any)
const AuthenticatedSlugFleetIndexRoute =
  AuthenticatedSlugFleetIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSlugFleetRoute,
  } as any)
const AuthenticatedSlugFleetAircraftIdRoute =
  AuthenticatedSlugFleetAircraftIdRouteImport.update({
    id: '/$aircraftId',
    path: '/$aircraftId',
    getParentRoute: () => AuthenticatedSlugFleetRoute,
  } as any)
const AuthenticatedSlugInvoicesIndexRoute =
  AuthenticatedSlugInvoicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSlugInvoicesRoute,
  } as any)
const AuthenticatedSlugInvoicesPeriodRoute =
  AuthenticatedSlugInvoicesPeriodRouteImport.update({
    id: '/$period',
    path: '/$period',
    getParentRoute: () => AuthenticatedSlugInvoicesRoute,
  } as any)
const AuthenticatedSlugSettingsIndexRoute =
  AuthenticatedSlugSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsAccountRoute =
  AuthenticatedSlugSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsAppearanceRoute =
  AuthenticatedSlugSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsIntegrationsRoute =
  AuthenticatedSlugSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsUnitsRoute =
  AuthenticatedSlugSettingsUnitsRouteImport.update({
    id: '/units',
    path: '/units',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsWorkspaceRoute =
  AuthenticatedSlugSettingsWorkspaceRouteImport.update({
    id: '/workspace',
    path: '/workspace',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugFleetAircraftIdAircraftRoute =
  AuthenticatedSlugFleetAircraftIdAircraftRouteImport.update({
    id: '/_aircraft',
    getParentRoute: () => AuthenticatedSlugFleetAircraftIdRoute,
  } as any)
const AuthenticatedSlugFleetAircraftIdAircraftIndexRoute =
  AuthenticatedSlugFleetAircraftIdAircraftIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSlugFleetAircraftIdAircraftRoute,
  } as any)
const AuthenticatedSlugFleetAircraftIdAircraftDocumentsRoute =
  AuthenticatedSlugFleetAircraftIdAircraftDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthenticatedSlugFleetAircraftIdAircraftRoute,
  } as any)
const AuthenticatedSlugFleetAircraftIdAircraftExpensesRoute =
  AuthenticatedSlugFleetAircraftIdAircraftExpensesRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => AuthenticatedSlugFleetAircraftIdAircraftRoute,
  } as any)
const AuthenticatedSlugFleetAircraftIdAircraftFlightsRoute =
  AuthenticatedSlugFleetAircraftIdAircraftFlightsRouteImport.update({
    id: '/flights',
    path: '/flights',
    getParentRoute: () => AuthenticatedSlugFleetAircraftIdAircraftRoute,
  } as any)
const AuthenticatedSlugFleetAircraftIdAircraftInfoRoute =
  AuthenticatedSlugFleetAircraftIdAircraftInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => AuthenticatedSlugFleetAircraftIdAircraftRoute,
  } as any)
const AuthenticatedSlugFleetAircraftIdAircraftOverviewRoute =
  AuthenticatedSlugFleetAircraftIdAircraftOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedSlugFleetAircraftIdAircraftRoute,
  } as any)
const AuthenticatedSlugFleetAircraftIdAircraftProgramsRoute =
  AuthenticatedSlugFleetAircraftIdAircraftProgramsRouteImport.update({
    id: '/programs',
    path: '/programs',
    getParentRoute: () => AuthenticatedSlugFleetAircraftIdAircraftRoute,
  } as any)
const AuthenticatedSlugFleetAircraftIdOverviewRecentActivityRoute =
  AuthenticatedSlugFleetAircraftIdOverviewRecentActivityRouteImport.update({
    id: '/overview/recent-activity',
    path: '/overview/recent-activity',
    getParentRoute: () => AuthenticatedSlugFleetAircraftIdRoute,
  } as any)
const AuthenticatedSlugFleetAircraftIdOverviewVendorsRoute =
  AuthenticatedSlugFleetAircraftIdOverviewVendorsRouteImport.update({
    id: '/overview/vendors',
    path: '/overview/vendors',
    getParentRoute: () => AuthenticatedSlugFleetAircraftIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/access-denied': typeof AuthAccessDeniedRoute
  '/invalid-link': typeof AuthInvalidLinkRoute
  '/invitation': typeof AuthInvitationRoute
  '/link-expired': typeof AuthLinkExpiredRoute
  '/login-verify': typeof AuthLoginVerifyRoute
  '/magic-link-sent': typeof AuthMagicLinkSentRoute
  '/session-expired': typeof AuthSessionExpiredRoute
  '/sign-in': typeof AuthSignInRoute
  '/$slug': typeof AuthenticatedSlugRouteWithChildren
  '/too-many-requests/': typeof AuthTooManyRequestsRoute
  '/$slug/admin': typeof AuthenticatedSlugAdminRouteWithChildren
  '/$slug/budget-forecast': typeof AuthenticatedSlugBudgetForecastRoute
  '/$slug/fleet': typeof AuthenticatedSlugFleetRouteWithChildren
  '/$slug/flights': typeof AuthenticatedSlugFlightsRoute
  '/$slug/invoices': typeof AuthenticatedSlugInvoicesRouteWithChildren
  '/$slug/monthly-reports': typeof AuthenticatedSlugMonthlyReportsRoute
  '/$slug/owner-portal': typeof AuthenticatedSlugOwnerPortalRoute
  '/$slug/price-library': typeof AuthenticatedSlugPriceLibraryRoute
  '/$slug/settings': typeof AuthenticatedSlugSettingsRouteWithChildren
  '/$slug/support': typeof AuthenticatedSlugSupportRoute
  '/$slug/': typeof AuthenticatedSlugIndexRoute
  '/$slug/admin/ai-models': typeof AuthenticatedSlugAdminAiModelsRoute
  '/$slug/admin/aircraft': typeof AuthenticatedSlugAdminAircraftRoute
  '/$slug/admin/crew': typeof AuthenticatedSlugAdminCrewRoute
  '/$slug/admin/operators': typeof AuthenticatedSlugAdminOperatorsRoute
  '/$slug/admin/owners': typeof AuthenticatedSlugAdminOwnersRoute
  '/$slug/admin/users': typeof AuthenticatedSlugAdminUsersRoute
  '/$slug/fleet/$aircraftId': typeof AuthenticatedSlugFleetAircraftIdRouteWithChildren
  '/$slug/invoices/$period': typeof AuthenticatedSlugInvoicesPeriodRoute
  '/$slug/settings/account': typeof AuthenticatedSlugSettingsAccountRoute
  '/$slug/settings/appearance': typeof AuthenticatedSlugSettingsAppearanceRoute
  '/$slug/settings/integrations': typeof AuthenticatedSlugSettingsIntegrationsRoute
  '/$slug/settings/units': typeof AuthenticatedSlugSettingsUnitsRoute
  '/$slug/settings/workspace': typeof AuthenticatedSlugSettingsWorkspaceRoute
  '/$slug/admin/': typeof AuthenticatedSlugAdminIndexRoute
  '/$slug/fleet/': typeof AuthenticatedSlugFleetIndexRoute
  '/$slug/invoices/': typeof AuthenticatedSlugInvoicesIndexRoute
  '/$slug/settings/': typeof AuthenticatedSlugSettingsIndexRoute
  '/$slug/fleet/$aircraftId/documents': typeof AuthenticatedSlugFleetAircraftIdAircraftDocumentsRoute
  '/$slug/fleet/$aircraftId/expenses': typeof AuthenticatedSlugFleetAircraftIdAircraftExpensesRoute
  '/$slug/fleet/$aircraftId/flights': typeof AuthenticatedSlugFleetAircraftIdAircraftFlightsRoute
  '/$slug/fleet/$aircraftId/info': typeof AuthenticatedSlugFleetAircraftIdAircraftInfoRoute
  '/$slug/fleet/$aircraftId/overview': typeof AuthenticatedSlugFleetAircraftIdAircraftOverviewRoute
  '/$slug/fleet/$aircraftId/programs': typeof AuthenticatedSlugFleetAircraftIdAircraftProgramsRoute
  '/$slug/fleet/$aircraftId/overview/recent-activity': typeof AuthenticatedSlugFleetAircraftIdOverviewRecentActivityRoute
  '/$slug/fleet/$aircraftId/overview/vendors': typeof AuthenticatedSlugFleetAircraftIdOverviewVendorsRoute
  '/$slug/fleet/$aircraftId/': typeof AuthenticatedSlugFleetAircraftIdAircraftIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/access-denied': typeof AuthAccessDeniedRoute
  '/invalid-link': typeof AuthInvalidLinkRoute
  '/invitation': typeof AuthInvitationRoute
  '/link-expired': typeof AuthLinkExpiredRoute
  '/login-verify': typeof AuthLoginVerifyRoute
  '/magic-link-sent': typeof AuthMagicLinkSentRoute
  '/session-expired': typeof AuthSessionExpiredRoute
  '/sign-in': typeof AuthSignInRoute
  '/too-many-requests': typeof AuthTooManyRequestsRoute
  '/$slug/budget-forecast': typeof AuthenticatedSlugBudgetForecastRoute
  '/$slug/flights': typeof AuthenticatedSlugFlightsRoute
  '/$slug/monthly-reports': typeof AuthenticatedSlugMonthlyReportsRoute
  '/$slug/owner-portal': typeof AuthenticatedSlugOwnerPortalRoute
  '/$slug/price-library': typeof AuthenticatedSlugPriceLibraryRoute
  '/$slug/support': typeof AuthenticatedSlugSupportRoute
  '/$slug': typeof AuthenticatedSlugIndexRoute
  '/$slug/admin/ai-models': typeof AuthenticatedSlugAdminAiModelsRoute
  '/$slug/admin/aircraft': typeof AuthenticatedSlugAdminAircraftRoute
  '/$slug/admin/crew': typeof AuthenticatedSlugAdminCrewRoute
  '/$slug/admin/operators': typeof AuthenticatedSlugAdminOperatorsRoute
  '/$slug/admin/owners': typeof AuthenticatedSlugAdminOwnersRoute
  '/$slug/admin/users': typeof AuthenticatedSlugAdminUsersRoute
  '/$slug/fleet/$aircraftId': typeof AuthenticatedSlugFleetAircraftIdAircraftIndexRoute
  '/$slug/invoices/$period': typeof AuthenticatedSlugInvoicesPeriodRoute
  '/$slug/settings/account': typeof AuthenticatedSlugSettingsAccountRoute
  '/$slug/settings/appearance': typeof AuthenticatedSlugSettingsAppearanceRoute
  '/$slug/settings/integrations': typeof AuthenticatedSlugSettingsIntegrationsRoute
  '/$slug/settings/units': typeof AuthenticatedSlugSettingsUnitsRoute
  '/$slug/settings/workspace': typeof AuthenticatedSlugSettingsWorkspaceRoute
  '/$slug/admin': typeof AuthenticatedSlugAdminIndexRoute
  '/$slug/fleet': typeof AuthenticatedSlugFleetIndexRoute
  '/$slug/invoices': typeof AuthenticatedSlugInvoicesIndexRoute
  '/$slug/settings': typeof AuthenticatedSlugSettingsIndexRoute
  '/$slug/fleet/$aircraftId/documents': typeof AuthenticatedSlugFleetAircraftIdAircraftDocumentsRoute
  '/$slug/fleet/$aircraftId/expenses': typeof AuthenticatedSlugFleetAircraftIdAircraftExpensesRoute
  '/$slug/fleet/$aircraftId/flights': typeof AuthenticatedSlugFleetAircraftIdAircraftFlightsRoute
  '/$slug/fleet/$aircraftId/info': typeof AuthenticatedSlugFleetAircraftIdAircraftInfoRoute
  '/$slug/fleet/$aircraftId/overview': typeof AuthenticatedSlugFleetAircraftIdAircraftOverviewRoute
  '/$slug/fleet/$aircraftId/programs': typeof AuthenticatedSlugFleetAircraftIdAircraftProgramsRoute
  '/$slug/fleet/$aircraftId/overview/recent-activity': typeof AuthenticatedSlugFleetAircraftIdOverviewRecentActivityRoute
  '/$slug/fleet/$aircraftId/overview/vendors': typeof AuthenticatedSlugFleetAircraftIdOverviewVendorsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/_auth/access-denied': typeof AuthAccessDeniedRoute
  '/_auth/invalid-link': typeof AuthInvalidLinkRoute
  '/_auth/invitation': typeof AuthInvitationRoute
  '/_auth/link-expired': typeof AuthLinkExpiredRoute
  '/_auth/login-verify': typeof AuthLoginVerifyRoute
  '/_auth/magic-link-sent': typeof AuthMagicLinkSentRoute
  '/_auth/session-expired': typeof AuthSessionExpiredRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_authenticated/$slug': typeof AuthenticatedSlugRouteWithChildren
  '/_auth/too-many-requests/': typeof AuthTooManyRequestsRoute
  '/_authenticated/$slug/admin': typeof AuthenticatedSlugAdminRouteWithChildren
  '/_authenticated/$slug/budget-forecast': typeof AuthenticatedSlugBudgetForecastRoute
  '/_authenticated/$slug/fleet': typeof AuthenticatedSlugFleetRouteWithChildren
  '/_authenticated/$slug/flights': typeof AuthenticatedSlugFlightsRoute
  '/_authenticated/$slug/invoices': typeof AuthenticatedSlugInvoicesRouteWithChildren
  '/_authenticated/$slug/monthly-reports': typeof AuthenticatedSlugMonthlyReportsRoute
  '/_authenticated/$slug/owner-portal': typeof AuthenticatedSlugOwnerPortalRoute
  '/_authenticated/$slug/price-library': typeof AuthenticatedSlugPriceLibraryRoute
  '/_authenticated/$slug/settings': typeof AuthenticatedSlugSettingsRouteWithChildren
  '/_authenticated/$slug/support': typeof AuthenticatedSlugSupportRoute
  '/_authenticated/$slug/': typeof AuthenticatedSlugIndexRoute
  '/_authenticated/$slug/admin/ai-models': typeof AuthenticatedSlugAdminAiModelsRoute
  '/_authenticated/$slug/admin/aircraft': typeof AuthenticatedSlugAdminAircraftRoute
  '/_authenticated/$slug/admin/crew': typeof AuthenticatedSlugAdminCrewRoute
  '/_authenticated/$slug/admin/operators': typeof AuthenticatedSlugAdminOperatorsRoute
  '/_authenticated/$slug/admin/owners': typeof AuthenticatedSlugAdminOwnersRoute
  '/_authenticated/$slug/admin/users': typeof AuthenticatedSlugAdminUsersRoute
  '/_authenticated/$slug/fleet/$aircraftId': typeof AuthenticatedSlugFleetAircraftIdRouteWithChildren
  '/_authenticated/$slug/invoices/$period': typeof AuthenticatedSlugInvoicesPeriodRoute
  '/_authenticated/$slug/settings/account': typeof AuthenticatedSlugSettingsAccountRoute
  '/_authenticated/$slug/settings/appearance': typeof AuthenticatedSlugSettingsAppearanceRoute
  '/_authenticated/$slug/settings/integrations': typeof AuthenticatedSlugSettingsIntegrationsRoute
  '/_authenticated/$slug/settings/units': typeof AuthenticatedSlugSettingsUnitsRoute
  '/_authenticated/$slug/settings/workspace': typeof AuthenticatedSlugSettingsWorkspaceRoute
  '/_authenticated/$slug/admin/': typeof AuthenticatedSlugAdminIndexRoute
  '/_authenticated/$slug/fleet/': typeof AuthenticatedSlugFleetIndexRoute
  '/_authenticated/$slug/invoices/': typeof AuthenticatedSlugInvoicesIndexRoute
  '/_authenticated/$slug/settings/': typeof AuthenticatedSlugSettingsIndexRoute
  '/_authenticated/$slug/fleet/$aircraftId/_aircraft': typeof AuthenticatedSlugFleetAircraftIdAircraftRouteWithChildren
  '/_authenticated/$slug/fleet/$aircraftId/_aircraft/documents': typeof AuthenticatedSlugFleetAircraftIdAircraftDocumentsRoute
  '/_authenticated/$slug/fleet/$aircraftId/_aircraft/expenses': typeof AuthenticatedSlugFleetAircraftIdAircraftExpensesRoute
  '/_authenticated/$slug/fleet/$aircraftId/_aircraft/flights': typeof AuthenticatedSlugFleetAircraftIdAircraftFlightsRoute
  '/_authenticated/$slug/fleet/$aircraftId/_aircraft/info': typeof AuthenticatedSlugFleetAircraftIdAircraftInfoRoute
  '/_authenticated/$slug/fleet/$aircraftId/_aircraft/overview': typeof AuthenticatedSlugFleetAircraftIdAircraftOverviewRoute
  '/_authenticated/$slug/fleet/$aircraftId/_aircraft/programs': typeof AuthenticatedSlugFleetAircraftIdAircraftProgramsRoute
  '/_authenticated/$slug/fleet/$aircraftId/overview/recent-activity': typeof AuthenticatedSlugFleetAircraftIdOverviewRecentActivityRoute
  '/_authenticated/$slug/fleet/$aircraftId/overview/vendors': typeof AuthenticatedSlugFleetAircraftIdOverviewVendorsRoute
  '/_authenticated/$slug/fleet/$aircraftId/_aircraft/': typeof AuthenticatedSlugFleetAircraftIdAircraftIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/access-denied'
    | '/invalid-link'
    | '/invitation'
    | '/link-expired'
    | '/login-verify'
    | '/magic-link-sent'
    | '/session-expired'
    | '/sign-in'
    | '/$slug'
    | '/too-many-requests/'
    | '/$slug/admin'
    | '/$slug/budget-forecast'
    | '/$slug/fleet'
    | '/$slug/flights'
    | '/$slug/invoices'
    | '/$slug/monthly-reports'
    | '/$slug/owner-portal'
    | '/$slug/price-library'
    | '/$slug/settings'
    | '/$slug/support'
    | '/$slug/'
    | '/$slug/admin/ai-models'
    | '/$slug/admin/aircraft'
    | '/$slug/admin/crew'
    | '/$slug/admin/operators'
    | '/$slug/admin/owners'
    | '/$slug/admin/users'
    | '/$slug/fleet/$aircraftId'
    | '/$slug/invoices/$period'
    | '/$slug/settings/account'
    | '/$slug/settings/appearance'
    | '/$slug/settings/integrations'
    | '/$slug/settings/units'
    | '/$slug/settings/workspace'
    | '/$slug/admin/'
    | '/$slug/fleet/'
    | '/$slug/invoices/'
    | '/$slug/settings/'
    | '/$slug/fleet/$aircraftId/documents'
    | '/$slug/fleet/$aircraftId/expenses'
    | '/$slug/fleet/$aircraftId/flights'
    | '/$slug/fleet/$aircraftId/info'
    | '/$slug/fleet/$aircraftId/overview'
    | '/$slug/fleet/$aircraftId/programs'
    | '/$slug/fleet/$aircraftId/overview/recent-activity'
    | '/$slug/fleet/$aircraftId/overview/vendors'
    | '/$slug/fleet/$aircraftId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/access-denied'
    | '/invalid-link'
    | '/invitation'
    | '/link-expired'
    | '/login-verify'
    | '/magic-link-sent'
    | '/session-expired'
    | '/sign-in'
    | '/too-many-requests'
    | '/$slug/budget-forecast'
    | '/$slug/flights'
    | '/$slug/monthly-reports'
    | '/$slug/owner-portal'
    | '/$slug/price-library'
    | '/$slug/support'
    | '/$slug'
    | '/$slug/admin/ai-models'
    | '/$slug/admin/aircraft'
    | '/$slug/admin/crew'
    | '/$slug/admin/operators'
    | '/$slug/admin/owners'
    | '/$slug/admin/users'
    | '/$slug/fleet/$aircraftId'
    | '/$slug/invoices/$period'
    | '/$slug/settings/account'
    | '/$slug/settings/appearance'
    | '/$slug/settings/integrations'
    | '/$slug/settings/units'
    | '/$slug/settings/workspace'
    | '/$slug/admin'
    | '/$slug/fleet'
    | '/$slug/invoices'
    | '/$slug/settings'
    | '/$slug/fleet/$aircraftId/documents'
    | '/$slug/fleet/$aircraftId/expenses'
    | '/$slug/fleet/$aircraftId/flights'
    | '/$slug/fleet/$aircraftId/info'
    | '/$slug/fleet/$aircraftId/overview'
    | '/$slug/fleet/$aircraftId/programs'
    | '/$slug/fleet/$aircraftId/overview/recent-activity'
    | '/$slug/fleet/$aircraftId/overview/vendors'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_authenticated'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/_auth/access-denied'
    | '/_auth/invalid-link'
    | '/_auth/invitation'
    | '/_auth/link-expired'
    | '/_auth/login-verify'
    | '/_auth/magic-link-sent'
    | '/_auth/session-expired'
    | '/_auth/sign-in'
    | '/_authenticated/$slug'
    | '/_auth/too-many-requests/'
    | '/_authenticated/$slug/admin'
    | '/_authenticated/$slug/budget-forecast'
    | '/_authenticated/$slug/fleet'
    | '/_authenticated/$slug/flights'
    | '/_authenticated/$slug/invoices'
    | '/_authenticated/$slug/monthly-reports'
    | '/_authenticated/$slug/owner-portal'
    | '/_authenticated/$slug/price-library'
    | '/_authenticated/$slug/settings'
    | '/_authenticated/$slug/support'
    | '/_authenticated/$slug/'
    | '/_authenticated/$slug/admin/ai-models'
    | '/_authenticated/$slug/admin/aircraft'
    | '/_authenticated/$slug/admin/crew'
    | '/_authenticated/$slug/admin/operators'
    | '/_authenticated/$slug/admin/owners'
    | '/_authenticated/$slug/admin/users'
    | '/_authenticated/$slug/fleet/$aircraftId'
    | '/_authenticated/$slug/invoices/$period'
    | '/_authenticated/$slug/settings/account'
    | '/_authenticated/$slug/settings/appearance'
    | '/_authenticated/$slug/settings/integrations'
    | '/_authenticated/$slug/settings/units'
    | '/_authenticated/$slug/settings/workspace'
    | '/_authenticated/$slug/admin/'
    | '/_authenticated/$slug/fleet/'
    | '/_authenticated/$slug/invoices/'
    | '/_authenticated/$slug/settings/'
    | '/_authenticated/$slug/fleet/$aircraftId/_aircraft'
    | '/_authenticated/$slug/fleet/$aircraftId/_aircraft/documents'
    | '/_authenticated/$slug/fleet/$aircraftId/_aircraft/expenses'
    | '/_authenticated/$slug/fleet/$aircraftId/_aircraft/flights'
    | '/_authenticated/$slug/fleet/$aircraftId/_aircraft/info'
    | '/_authenticated/$slug/fleet/$aircraftId/_aircraft/overview'
    | '/_authenticated/$slug/fleet/$aircraftId/_aircraft/programs'
    | '/_authenticated/$slug/fleet/$aircraftId/overview/recent-activity'
    | '/_authenticated/$slug/fleet/$aircraftId/overview/vendors'
    | '/_authenticated/$slug/fleet/$aircraftId/_aircraft/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsAndConditionsRoute: typeof TermsAndConditionsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-and-conditions': {
      id: '/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof TermsAndConditionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/access-denied': {
      id: '/_auth/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AuthAccessDeniedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invalid-link': {
      id: '/_auth/invalid-link'
      path: '/invalid-link'
      fullPath: '/invalid-link'
      preLoaderRoute: typeof AuthInvalidLinkRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invitation': {
      id: '/_auth/invitation'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof AuthInvitationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/link-expired': {
      id: '/_auth/link-expired'
      path: '/link-expired'
      fullPath: '/link-expired'
      preLoaderRoute: typeof AuthLinkExpiredRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login-verify': {
      id: '/_auth/login-verify'
      path: '/login-verify'
      fullPath: '/login-verify'
      preLoaderRoute: typeof AuthLoginVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/magic-link-sent': {
      id: '/_auth/magic-link-sent'
      path: '/magic-link-sent'
      fullPath: '/magic-link-sent'
      preLoaderRoute: typeof AuthMagicLinkSentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/session-expired': {
      id: '/_auth/session-expired'
      path: '/session-expired'
      fullPath: '/session-expired'
      preLoaderRoute: typeof AuthSessionExpiredRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/$slug': {
      id: '/_authenticated/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof AuthenticatedSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/too-many-requests/': {
      id: '/_auth/too-many-requests/'
      path: '/too-many-requests'
      fullPath: '/too-many-requests/'
      preLoaderRoute: typeof AuthTooManyRequestsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/$slug/': {
      id: '/_authenticated/$slug/'
      path: '/'
      fullPath: '/$slug/'
      preLoaderRoute: typeof AuthenticatedSlugIndexRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/admin': {
      id: '/_authenticated/$slug/admin'
      path: '/admin'
      fullPath: '/$slug/admin'
      preLoaderRoute: typeof AuthenticatedSlugAdminRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/budget-forecast': {
      id: '/_authenticated/$slug/budget-forecast'
      path: '/budget-forecast'
      fullPath: '/$slug/budget-forecast'
      preLoaderRoute: typeof AuthenticatedSlugBudgetForecastRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/fleet': {
      id: '/_authenticated/$slug/fleet'
      path: '/fleet'
      fullPath: '/$slug/fleet'
      preLoaderRoute: typeof AuthenticatedSlugFleetRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/flights': {
      id: '/_authenticated/$slug/flights'
      path: '/flights'
      fullPath: '/$slug/flights'
      preLoaderRoute: typeof AuthenticatedSlugFlightsRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/invoices': {
      id: '/_authenticated/$slug/invoices'
      path: '/invoices'
      fullPath: '/$slug/invoices'
      preLoaderRoute: typeof AuthenticatedSlugInvoicesRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/monthly-reports': {
      id: '/_authenticated/$slug/monthly-reports'
      path: '/monthly-reports'
      fullPath: '/$slug/monthly-reports'
      preLoaderRoute: typeof AuthenticatedSlugMonthlyReportsRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/owner-portal': {
      id: '/_authenticated/$slug/owner-portal'
      path: '/owner-portal'
      fullPath: '/$slug/owner-portal'
      preLoaderRoute: typeof AuthenticatedSlugOwnerPortalRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/price-library': {
      id: '/_authenticated/$slug/price-library'
      path: '/price-library'
      fullPath: '/$slug/price-library'
      preLoaderRoute: typeof AuthenticatedSlugPriceLibraryRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/settings': {
      id: '/_authenticated/$slug/settings'
      path: '/settings'
      fullPath: '/$slug/settings'
      preLoaderRoute: typeof AuthenticatedSlugSettingsRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/support': {
      id: '/_authenticated/$slug/support'
      path: '/support'
      fullPath: '/$slug/support'
      preLoaderRoute: typeof AuthenticatedSlugSupportRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/admin/': {
      id: '/_authenticated/$slug/admin/'
      path: '/'
      fullPath: '/$slug/admin/'
      preLoaderRoute: typeof AuthenticatedSlugAdminIndexRouteImport
      parentRoute: typeof AuthenticatedSlugAdminRoute
    }
    '/_authenticated/$slug/admin/ai-models': {
      id: '/_authenticated/$slug/admin/ai-models'
      path: '/ai-models'
      fullPath: '/$slug/admin/ai-models'
      preLoaderRoute: typeof AuthenticatedSlugAdminAiModelsRouteImport
      parentRoute: typeof AuthenticatedSlugAdminRoute
    }
    '/_authenticated/$slug/admin/aircraft': {
      id: '/_authenticated/$slug/admin/aircraft'
      path: '/aircraft'
      fullPath: '/$slug/admin/aircraft'
      preLoaderRoute: typeof AuthenticatedSlugAdminAircraftRouteImport
      parentRoute: typeof AuthenticatedSlugAdminRoute
    }
    '/_authenticated/$slug/admin/crew': {
      id: '/_authenticated/$slug/admin/crew'
      path: '/crew'
      fullPath: '/$slug/admin/crew'
      preLoaderRoute: typeof AuthenticatedSlugAdminCrewRouteImport
      parentRoute: typeof AuthenticatedSlugAdminRoute
    }
    '/_authenticated/$slug/admin/operators': {
      id: '/_authenticated/$slug/admin/operators'
      path: '/operators'
      fullPath: '/$slug/admin/operators'
      preLoaderRoute: typeof AuthenticatedSlugAdminOperatorsRouteImport
      parentRoute: typeof AuthenticatedSlugAdminRoute
    }
    '/_authenticated/$slug/admin/owners': {
      id: '/_authenticated/$slug/admin/owners'
      path: '/owners'
      fullPath: '/$slug/admin/owners'
      preLoaderRoute: typeof AuthenticatedSlugAdminOwnersRouteImport
      parentRoute: typeof AuthenticatedSlugAdminRoute
    }
    '/_authenticated/$slug/admin/users': {
      id: '/_authenticated/$slug/admin/users'
      path: '/users'
      fullPath: '/$slug/admin/users'
      preLoaderRoute: typeof AuthenticatedSlugAdminUsersRouteImport
      parentRoute: typeof AuthenticatedSlugAdminRoute
    }
    '/_authenticated/$slug/fleet/': {
      id: '/_authenticated/$slug/fleet/'
      path: '/'
      fullPath: '/$slug/fleet/'
      preLoaderRoute: typeof AuthenticatedSlugFleetIndexRouteImport
      parentRoute: typeof AuthenticatedSlugFleetRoute
    }
    '/_authenticated/$slug/fleet/$aircraftId': {
      id: '/_authenticated/$slug/fleet/$aircraftId'
      path: '/$aircraftId'
      fullPath: '/$slug/fleet/$aircraftId'
      preLoaderRoute: typeof AuthenticatedSlugFleetAircraftIdRouteImport
      parentRoute: typeof AuthenticatedSlugFleetRoute
    }
    '/_authenticated/$slug/invoices/': {
      id: '/_authenticated/$slug/invoices/'
      path: '/'
      fullPath: '/$slug/invoices/'
      preLoaderRoute: typeof AuthenticatedSlugInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedSlugInvoicesRoute
    }
    '/_authenticated/$slug/invoices/$period': {
      id: '/_authenticated/$slug/invoices/$period'
      path: '/$period'
      fullPath: '/$slug/invoices/$period'
      preLoaderRoute: typeof AuthenticatedSlugInvoicesPeriodRouteImport
      parentRoute: typeof AuthenticatedSlugInvoicesRoute
    }
    '/_authenticated/$slug/settings/': {
      id: '/_authenticated/$slug/settings/'
      path: '/'
      fullPath: '/$slug/settings/'
      preLoaderRoute: typeof AuthenticatedSlugSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/account': {
      id: '/_authenticated/$slug/settings/account'
      path: '/account'
      fullPath: '/$slug/settings/account'
      preLoaderRoute: typeof AuthenticatedSlugSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/appearance': {
      id: '/_authenticated/$slug/settings/appearance'
      path: '/appearance'
      fullPath: '/$slug/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSlugSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/integrations': {
      id: '/_authenticated/$slug/settings/integrations'
      path: '/integrations'
      fullPath: '/$slug/settings/integrations'
      preLoaderRoute: typeof AuthenticatedSlugSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/units': {
      id: '/_authenticated/$slug/settings/units'
      path: '/units'
      fullPath: '/$slug/settings/units'
      preLoaderRoute: typeof AuthenticatedSlugSettingsUnitsRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/workspace': {
      id: '/_authenticated/$slug/settings/workspace'
      path: '/workspace'
      fullPath: '/$slug/settings/workspace'
      preLoaderRoute: typeof AuthenticatedSlugSettingsWorkspaceRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/fleet/$aircraftId/_aircraft': {
      id: '/_authenticated/$slug/fleet/$aircraftId/_aircraft'
      path: ''
      fullPath: '/$slug/fleet/$aircraftId'
      preLoaderRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftRouteImport
      parentRoute: typeof AuthenticatedSlugFleetAircraftIdRoute
    }
    '/_authenticated/$slug/fleet/$aircraftId/_aircraft/': {
      id: '/_authenticated/$slug/fleet/$aircraftId/_aircraft/'
      path: '/'
      fullPath: '/$slug/fleet/$aircraftId/'
      preLoaderRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftIndexRouteImport
      parentRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftRoute
    }
    '/_authenticated/$slug/fleet/$aircraftId/_aircraft/documents': {
      id: '/_authenticated/$slug/fleet/$aircraftId/_aircraft/documents'
      path: '/documents'
      fullPath: '/$slug/fleet/$aircraftId/documents'
      preLoaderRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftDocumentsRouteImport
      parentRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftRoute
    }
    '/_authenticated/$slug/fleet/$aircraftId/_aircraft/expenses': {
      id: '/_authenticated/$slug/fleet/$aircraftId/_aircraft/expenses'
      path: '/expenses'
      fullPath: '/$slug/fleet/$aircraftId/expenses'
      preLoaderRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftExpensesRouteImport
      parentRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftRoute
    }
    '/_authenticated/$slug/fleet/$aircraftId/_aircraft/flights': {
      id: '/_authenticated/$slug/fleet/$aircraftId/_aircraft/flights'
      path: '/flights'
      fullPath: '/$slug/fleet/$aircraftId/flights'
      preLoaderRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftFlightsRouteImport
      parentRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftRoute
    }
    '/_authenticated/$slug/fleet/$aircraftId/_aircraft/info': {
      id: '/_authenticated/$slug/fleet/$aircraftId/_aircraft/info'
      path: '/info'
      fullPath: '/$slug/fleet/$aircraftId/info'
      preLoaderRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftInfoRouteImport
      parentRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftRoute
    }
    '/_authenticated/$slug/fleet/$aircraftId/_aircraft/overview': {
      id: '/_authenticated/$slug/fleet/$aircraftId/_aircraft/overview'
      path: '/overview'
      fullPath: '/$slug/fleet/$aircraftId/overview'
      preLoaderRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftOverviewRouteImport
      parentRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftRoute
    }
    '/_authenticated/$slug/fleet/$aircraftId/_aircraft/programs': {
      id: '/_authenticated/$slug/fleet/$aircraftId/_aircraft/programs'
      path: '/programs'
      fullPath: '/$slug/fleet/$aircraftId/programs'
      preLoaderRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftProgramsRouteImport
      parentRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftRoute
    }
    '/_authenticated/$slug/fleet/$aircraftId/overview/recent-activity': {
      id: '/_authenticated/$slug/fleet/$aircraftId/overview/recent-activity'
      path: '/overview/recent-activity'
      fullPath: '/$slug/fleet/$aircraftId/overview/recent-activity'
      preLoaderRoute: typeof AuthenticatedSlugFleetAircraftIdOverviewRecentActivityRouteImport
      parentRoute: typeof AuthenticatedSlugFleetAircraftIdRoute
    }
    '/_authenticated/$slug/fleet/$aircraftId/overview/vendors': {
      id: '/_authenticated/$slug/fleet/$aircraftId/overview/vendors'
      path: '/overview/vendors'
      fullPath: '/$slug/fleet/$aircraftId/overview/vendors'
      preLoaderRoute: typeof AuthenticatedSlugFleetAircraftIdOverviewVendorsRouteImport
      parentRoute: typeof AuthenticatedSlugFleetAircraftIdRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAccessDeniedRoute: typeof AuthAccessDeniedRoute
  AuthInvalidLinkRoute: typeof AuthInvalidLinkRoute
  AuthInvitationRoute: typeof AuthInvitationRoute
  AuthLinkExpiredRoute: typeof AuthLinkExpiredRoute
  AuthLoginVerifyRoute: typeof AuthLoginVerifyRoute
  AuthMagicLinkSentRoute: typeof AuthMagicLinkSentRoute
  AuthSessionExpiredRoute: typeof AuthSessionExpiredRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthTooManyRequestsRoute: typeof AuthTooManyRequestsRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccessDeniedRoute: AuthAccessDeniedRoute,
  AuthInvalidLinkRoute: AuthInvalidLinkRoute,
  AuthInvitationRoute: AuthInvitationRoute,
  AuthLinkExpiredRoute: AuthLinkExpiredRoute,
  AuthLoginVerifyRoute: AuthLoginVerifyRoute,
  AuthMagicLinkSentRoute: AuthMagicLinkSentRoute,
  AuthSessionExpiredRoute: AuthSessionExpiredRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthTooManyRequestsRoute: AuthTooManyRequestsRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedSlugAdminRouteChildren {
  AuthenticatedSlugAdminAiModelsRoute: typeof AuthenticatedSlugAdminAiModelsRoute
  AuthenticatedSlugAdminAircraftRoute: typeof AuthenticatedSlugAdminAircraftRoute
  AuthenticatedSlugAdminCrewRoute: typeof AuthenticatedSlugAdminCrewRoute
  AuthenticatedSlugAdminOperatorsRoute: typeof AuthenticatedSlugAdminOperatorsRoute
  AuthenticatedSlugAdminOwnersRoute: typeof AuthenticatedSlugAdminOwnersRoute
  AuthenticatedSlugAdminUsersRoute: typeof AuthenticatedSlugAdminUsersRoute
  AuthenticatedSlugAdminIndexRoute: typeof AuthenticatedSlugAdminIndexRoute
}

const AuthenticatedSlugAdminRouteChildren: AuthenticatedSlugAdminRouteChildren =
  {
    AuthenticatedSlugAdminAiModelsRoute: AuthenticatedSlugAdminAiModelsRoute,
    AuthenticatedSlugAdminAircraftRoute: AuthenticatedSlugAdminAircraftRoute,
    AuthenticatedSlugAdminCrewRoute: AuthenticatedSlugAdminCrewRoute,
    AuthenticatedSlugAdminOperatorsRoute: AuthenticatedSlugAdminOperatorsRoute,
    AuthenticatedSlugAdminOwnersRoute: AuthenticatedSlugAdminOwnersRoute,
    AuthenticatedSlugAdminUsersRoute: AuthenticatedSlugAdminUsersRoute,
    AuthenticatedSlugAdminIndexRoute: AuthenticatedSlugAdminIndexRoute,
  }

const AuthenticatedSlugAdminRouteWithChildren =
  AuthenticatedSlugAdminRoute._addFileChildren(
    AuthenticatedSlugAdminRouteChildren,
  )

interface AuthenticatedSlugFleetAircraftIdAircraftRouteChildren {
  AuthenticatedSlugFleetAircraftIdAircraftDocumentsRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftDocumentsRoute
  AuthenticatedSlugFleetAircraftIdAircraftExpensesRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftExpensesRoute
  AuthenticatedSlugFleetAircraftIdAircraftFlightsRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftFlightsRoute
  AuthenticatedSlugFleetAircraftIdAircraftInfoRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftInfoRoute
  AuthenticatedSlugFleetAircraftIdAircraftOverviewRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftOverviewRoute
  AuthenticatedSlugFleetAircraftIdAircraftProgramsRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftProgramsRoute
  AuthenticatedSlugFleetAircraftIdAircraftIndexRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftIndexRoute
}

const AuthenticatedSlugFleetAircraftIdAircraftRouteChildren: AuthenticatedSlugFleetAircraftIdAircraftRouteChildren =
  {
    AuthenticatedSlugFleetAircraftIdAircraftDocumentsRoute:
      AuthenticatedSlugFleetAircraftIdAircraftDocumentsRoute,
    AuthenticatedSlugFleetAircraftIdAircraftExpensesRoute:
      AuthenticatedSlugFleetAircraftIdAircraftExpensesRoute,
    AuthenticatedSlugFleetAircraftIdAircraftFlightsRoute:
      AuthenticatedSlugFleetAircraftIdAircraftFlightsRoute,
    AuthenticatedSlugFleetAircraftIdAircraftInfoRoute:
      AuthenticatedSlugFleetAircraftIdAircraftInfoRoute,
    AuthenticatedSlugFleetAircraftIdAircraftOverviewRoute:
      AuthenticatedSlugFleetAircraftIdAircraftOverviewRoute,
    AuthenticatedSlugFleetAircraftIdAircraftProgramsRoute:
      AuthenticatedSlugFleetAircraftIdAircraftProgramsRoute,
    AuthenticatedSlugFleetAircraftIdAircraftIndexRoute:
      AuthenticatedSlugFleetAircraftIdAircraftIndexRoute,
  }

const AuthenticatedSlugFleetAircraftIdAircraftRouteWithChildren =
  AuthenticatedSlugFleetAircraftIdAircraftRoute._addFileChildren(
    AuthenticatedSlugFleetAircraftIdAircraftRouteChildren,
  )

interface AuthenticatedSlugFleetAircraftIdRouteChildren {
  AuthenticatedSlugFleetAircraftIdAircraftRoute: typeof AuthenticatedSlugFleetAircraftIdAircraftRouteWithChildren
  AuthenticatedSlugFleetAircraftIdOverviewRecentActivityRoute: typeof AuthenticatedSlugFleetAircraftIdOverviewRecentActivityRoute
  AuthenticatedSlugFleetAircraftIdOverviewVendorsRoute: typeof AuthenticatedSlugFleetAircraftIdOverviewVendorsRoute
}

const AuthenticatedSlugFleetAircraftIdRouteChildren: AuthenticatedSlugFleetAircraftIdRouteChildren =
  {
    AuthenticatedSlugFleetAircraftIdAircraftRoute:
      AuthenticatedSlugFleetAircraftIdAircraftRouteWithChildren,
    AuthenticatedSlugFleetAircraftIdOverviewRecentActivityRoute:
      AuthenticatedSlugFleetAircraftIdOverviewRecentActivityRoute,
    AuthenticatedSlugFleetAircraftIdOverviewVendorsRoute:
      AuthenticatedSlugFleetAircraftIdOverviewVendorsRoute,
  }

const AuthenticatedSlugFleetAircraftIdRouteWithChildren =
  AuthenticatedSlugFleetAircraftIdRoute._addFileChildren(
    AuthenticatedSlugFleetAircraftIdRouteChildren,
  )

interface AuthenticatedSlugFleetRouteChildren {
  AuthenticatedSlugFleetAircraftIdRoute: typeof AuthenticatedSlugFleetAircraftIdRouteWithChildren
  AuthenticatedSlugFleetIndexRoute: typeof AuthenticatedSlugFleetIndexRoute
}

const AuthenticatedSlugFleetRouteChildren: AuthenticatedSlugFleetRouteChildren =
  {
    AuthenticatedSlugFleetAircraftIdRoute:
      AuthenticatedSlugFleetAircraftIdRouteWithChildren,
    AuthenticatedSlugFleetIndexRoute: AuthenticatedSlugFleetIndexRoute,
  }

const AuthenticatedSlugFleetRouteWithChildren =
  AuthenticatedSlugFleetRoute._addFileChildren(
    AuthenticatedSlugFleetRouteChildren,
  )

interface AuthenticatedSlugInvoicesRouteChildren {
  AuthenticatedSlugInvoicesPeriodRoute: typeof AuthenticatedSlugInvoicesPeriodRoute
  AuthenticatedSlugInvoicesIndexRoute: typeof AuthenticatedSlugInvoicesIndexRoute
}

const AuthenticatedSlugInvoicesRouteChildren: AuthenticatedSlugInvoicesRouteChildren =
  {
    AuthenticatedSlugInvoicesPeriodRoute: AuthenticatedSlugInvoicesPeriodRoute,
    AuthenticatedSlugInvoicesIndexRoute: AuthenticatedSlugInvoicesIndexRoute,
  }

const AuthenticatedSlugInvoicesRouteWithChildren =
  AuthenticatedSlugInvoicesRoute._addFileChildren(
    AuthenticatedSlugInvoicesRouteChildren,
  )

interface AuthenticatedSlugSettingsRouteChildren {
  AuthenticatedSlugSettingsAccountRoute: typeof AuthenticatedSlugSettingsAccountRoute
  AuthenticatedSlugSettingsAppearanceRoute: typeof AuthenticatedSlugSettingsAppearanceRoute
  AuthenticatedSlugSettingsIntegrationsRoute: typeof AuthenticatedSlugSettingsIntegrationsRoute
  AuthenticatedSlugSettingsUnitsRoute: typeof AuthenticatedSlugSettingsUnitsRoute
  AuthenticatedSlugSettingsWorkspaceRoute: typeof AuthenticatedSlugSettingsWorkspaceRoute
  AuthenticatedSlugSettingsIndexRoute: typeof AuthenticatedSlugSettingsIndexRoute
}

const AuthenticatedSlugSettingsRouteChildren: AuthenticatedSlugSettingsRouteChildren =
  {
    AuthenticatedSlugSettingsAccountRoute:
      AuthenticatedSlugSettingsAccountRoute,
    AuthenticatedSlugSettingsAppearanceRoute:
      AuthenticatedSlugSettingsAppearanceRoute,
    AuthenticatedSlugSettingsIntegrationsRoute:
      AuthenticatedSlugSettingsIntegrationsRoute,
    AuthenticatedSlugSettingsUnitsRoute: AuthenticatedSlugSettingsUnitsRoute,
    AuthenticatedSlugSettingsWorkspaceRoute:
      AuthenticatedSlugSettingsWorkspaceRoute,
    AuthenticatedSlugSettingsIndexRoute: AuthenticatedSlugSettingsIndexRoute,
  }

const AuthenticatedSlugSettingsRouteWithChildren =
  AuthenticatedSlugSettingsRoute._addFileChildren(
    AuthenticatedSlugSettingsRouteChildren,
  )

interface AuthenticatedSlugRouteChildren {
  AuthenticatedSlugAdminRoute: typeof AuthenticatedSlugAdminRouteWithChildren
  AuthenticatedSlugBudgetForecastRoute: typeof AuthenticatedSlugBudgetForecastRoute
  AuthenticatedSlugFleetRoute: typeof AuthenticatedSlugFleetRouteWithChildren
  AuthenticatedSlugFlightsRoute: typeof AuthenticatedSlugFlightsRoute
  AuthenticatedSlugInvoicesRoute: typeof AuthenticatedSlugInvoicesRouteWithChildren
  AuthenticatedSlugMonthlyReportsRoute: typeof AuthenticatedSlugMonthlyReportsRoute
  AuthenticatedSlugOwnerPortalRoute: typeof AuthenticatedSlugOwnerPortalRoute
  AuthenticatedSlugPriceLibraryRoute: typeof AuthenticatedSlugPriceLibraryRoute
  AuthenticatedSlugSettingsRoute: typeof AuthenticatedSlugSettingsRouteWithChildren
  AuthenticatedSlugSupportRoute: typeof AuthenticatedSlugSupportRoute
  AuthenticatedSlugIndexRoute: typeof AuthenticatedSlugIndexRoute
}

const AuthenticatedSlugRouteChildren: AuthenticatedSlugRouteChildren = {
  AuthenticatedSlugAdminRoute: AuthenticatedSlugAdminRouteWithChildren,
  AuthenticatedSlugBudgetForecastRoute: AuthenticatedSlugBudgetForecastRoute,
  AuthenticatedSlugFleetRoute: AuthenticatedSlugFleetRouteWithChildren,
  AuthenticatedSlugFlightsRoute: AuthenticatedSlugFlightsRoute,
  AuthenticatedSlugInvoicesRoute: AuthenticatedSlugInvoicesRouteWithChildren,
  AuthenticatedSlugMonthlyReportsRoute: AuthenticatedSlugMonthlyReportsRoute,
  AuthenticatedSlugOwnerPortalRoute: AuthenticatedSlugOwnerPortalRoute,
  AuthenticatedSlugPriceLibraryRoute: AuthenticatedSlugPriceLibraryRoute,
  AuthenticatedSlugSettingsRoute: AuthenticatedSlugSettingsRouteWithChildren,
  AuthenticatedSlugSupportRoute: AuthenticatedSlugSupportRoute,
  AuthenticatedSlugIndexRoute: AuthenticatedSlugIndexRoute,
}

const AuthenticatedSlugRouteWithChildren =
  AuthenticatedSlugRoute._addFileChildren(AuthenticatedSlugRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedSlugRoute: typeof AuthenticatedSlugRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSlugRoute: AuthenticatedSlugRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsAndConditionsRoute: TermsAndConditionsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
